package com.merkost.handpass.admin.components

import androidx.compose.runtime.Composable
import com.merkost.handpass.sharedweb.components.WebCard
import com.merkost.handpass.sharedweb.components.WebCardPadding
import com.merkost.handpass.sharedweb.theme.HandpassSpacing
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit

enum class AdminCardPadding(val padding: CSSSizeValue<CSSUnit.px>) {
    Compact(HandpassSpacing.MD), Default(HandpassSpacing.Default), Spacious(HandpassSpacing.XL)
}

@Composable
fun AdminCard(
    paddingScale: AdminCardPadding = AdminCardPadding.Default,
    onClick: (() -> Unit)? = null,
    content: @Composable () -> Unit,
) {
    val webPadding = when (paddingScale) {
        AdminCardPadding.Compact -> WebCardPadding.Compact
        AdminCardPadding.Default -> WebCardPadding.Default
        AdminCardPadding.Spacious -> WebCardPadding.Spacious
    }
    WebCard(onClick = onClick, padding = webPadding, content = content)
}
